<template>
    <picture v-if="!isBackgroundImage" :data-iesrc="fallbackUrl || imageUrl" :data-picture-class="pictureClass">
        <source media="(max-width: 585px)" :srcset="imageUrl" :type="mimeType">
        <source v-if="imageUrlTablet" media="(min-width: 586px) and (max-width: 991px)" :srcset="imageUrlTablet"
                :type="mimeType">
        <source v-else media="(min-width: 586px)" :srcset="imageUrl" :type="mimeType">
        <source v-if="imageUrlDesktop" media="(min-width: 992px)" :srcset="imageUrlDesktop" :type="mimeType">
        <source v-else-if="imageUrlTablet" media="(min-width: 586px)" :srcset="imageUrlTablet" :type="mimeType">
        <source v-else media="(min-width: 768px)" :srcset="imageUrl" :type="mimeType">
        <source v-if="fallbackUrl" :srcset="fallbackUrl">
    </picture>
    <div v-else :data-background-image="backgroundSource" :class="pictureClass">
        <slot></slot>
    </div>
</template>

<script>
    import lozad from 'ceres/app/plugins/lozad';
    import {detectWebP} from 'ceres/app/helper/featureDetect';

    export default {
        props: {
            imageUrl: String,
            imageUrlTablet: {
                type: String,
                default: '',
            },
            imageUrlDesktop: {
                type: String,
                default: '',
            },
            fallbackUrl: String,
            isBackgroundImage: Boolean,
            pictureClass: String,
        },

        data() {
            return {
                supported: undefined,
            };
        },

        mounted() {
            detectWebP(((supported) => {
                this.supported = supported;
                this.$nextTick(() => {
                    if (!this.isBackgroundImage) {
                        this.$el.classList.toggle('lozad');
                    }
                    lozad(this.$el).observe();
                });
            }));
        },

        watch:
            {
                imageUrl() {
                    this.$nextTick(() => {
                        this.$el.setAttribute('data-loaded', false);
                        lozad(this.$el).triggerLoad(this.$el);
                    });
                },

                imageUrlDesktop() {
                    this.$nextTick(() => {
                        this.$el.setAttribute('data-loaded', false);
                        lozad(this.$el).triggerLoad(this.$el);
                    });
                },
            },

        computed: {
            /**
             *  Determine appropriate image url to use as background source
             */
            backgroundSource() {
                if (this.imageUrl && this.mimeType) {
                    return this.supported ? this.imageUrl : this.fallbackUrl;
                }
                else {
                    return this.imageUrl || this.fallbackUrl;
                }
            },

            /**
             * Check if url points to a .webp image and return appropriate mime-type
             */
            mimeType() {
				const matches = this.imageUrl?.match(/.?(\.\w+)(?:$|\?)/);

                if (matches) {
                    return matches[1] === '.webp' ? 'image/webp' : null;
                }

                return null;
            },
        },
    };
</script>
